import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    sectionContent: {
        fontSize: 16,
        paddingTop: theme.spacing(1, 3),
        margin: 0,
        flexShrink: 0,
        marginTop: theme.spacing(2),
    },
    workspaceSelectorAboveOverlay: {
        position: "relative",
        zIndex: 101,
    },
    loadingContainer: {
        display: "flex",
        width: "100%",
        height: "80vh",
        alignItems: "center",
        justifyContent: "center",
    },
    workspaceNameBox: {
        marginTop: theme.spacing(2),
        paddingBottom: theme.spacing(1),
    },
    guidBox: {
        marginTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
    },
    organizationNameBox: {
        marginTop: theme.spacing(2),
        paddingBottom: theme.spacing(1),
    },
    organizationVatId: {
        marginTop: theme.spacing(1),
    },
    guidTooltipBox: {
        display: "block",
    },
    tabPanel: {
        padding: 0,
    },
}));
